export { default } from './Landing';



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutLandingPage/Content/Landing/index.js